'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _utils = require('helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./MoreButton.scss');

var MoreButton = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MoreButton, _Component);

  function MoreButton() {
    (0, _classCallCheck3.default)(this, MoreButton);
    return (0, _possibleConstructorReturn3.default)(this, (MoreButton.__proto__ || (0, _getPrototypeOf2.default)(MoreButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(MoreButton, [{
    key: 'onClick',
    value: function onClick(e) {
      var _props = this.props,
          onClick = _props.onClick,
          loading = _props.loading;

      if (!loading) {
        onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          loading = _props2.loading,
          containerClass = _props2.containerClass,
          buttonClass = _props2.buttonClass;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.more, containerClass) },
        _react2.default.createElement('i', { className: (0, _bind2.default)(styles.moreIcon, buttonClass, (0, _defineProperty3.default)({}, styles.loading, loading)), onClick: this.onClick }),
        _react2.default.createElement(_Loader2.default, { onClick: _utils.stopEvent, show: loading, small: true, transparent: true, mask: true })
      );
    }
  }]);
  return MoreButton;
}(_react.Component), _class2.propTypes = {
  buttonClass: _propTypes2.default.string,
  containerClass: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
}, _class2.defaultProps = {
  loading: false,
  onClick: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
exports.default = MoreButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MoreButton/MoreButton.js
// module id = 515
// module chunks = 1